import { FormGroup, Select, Text } from '@ksyos/design-system';
import { useEffect } from 'react';
import type { HolterGradingData } from '@common/validation/customControls/cardiology/holter/holterGradingSchemas';
import type { HolterExaminationRequestBase } from '@common/validation/customControls/cardiology/holter/utils/utils';
import {
    HolterConclusionOption,
    HolterGradingAdvice,
    HolterGradingUrgency,
    holterGradingUrgencyOptions,
} from '@common/validation/customControls/cardiology/holter/utils/gradingAndConsultUtils';
import { useEditFormSectionInputFieldContext } from '@frontend/formEngine/editForm/useEditFormContext';
import { getValidationErrorTranslation, useProcessActivityEditContext } from '@frontend/utils';

export function HolterGradingUrgencySelect() {
    const { data, errors } = useProcessActivityEditContext<HolterGradingData>();
    const { onChange } = useEditFormSectionInputFieldContext<HolterExaminationRequestBase>();
    const ifConclusionIsNotAlarmerendAndAdviceIsArrayButNotIncludingUrgentAdvice =
        data?.conclusion !== HolterConclusionOption.alarmerend_afwijkend &&
        Array.isArray(data?.advice) &&
        !data?.advice.some((advice) =>
            [
                HolterGradingAdvice.verwijzing_polikliniek_cardiologie,
                HolterGradingAdvice.aanvullend_slaaponderzoek_naar_osas_viaKsyos,
                HolterGradingAdvice.opvolgend_teleconsult_cardioloog_via_ksyos,
            ].includes(advice)
        ) &&
        data?.urgency !== null;
    const ifConclusionIsNotAlarmerendAndAdviceIsNull =
        data?.conclusion !== HolterConclusionOption.alarmerend_afwijkend && !data?.advice && data?.urgency !== null;

    useEffect(() => {
        if (data?.conclusion === HolterConclusionOption.alarmerend_afwijkend) {
            onChange(HolterGradingUrgency.binnen_een_dag);
        }
    }, [data?.conclusion]);

    useEffect(() => {
        if (
            ifConclusionIsNotAlarmerendAndAdviceIsArrayButNotIncludingUrgentAdvice ||
            ifConclusionIsNotAlarmerendAndAdviceIsNull
        ) {
            onChange(null);
        }
    }, [data?.conclusion, data?.advice, data?.urgency]);

    if (data?.conclusion === HolterConclusionOption.alarmerend_afwijkend) {
        return (
            <FormGroup
                isRequired
                label="Urgentie verwijzing"
            >
                <Text
                    size="sm"
                    sx={{ mb: '5px', mt: '5px' }}
                >
                    {HolterGradingUrgency.binnen_een_dag}
                </Text>
            </FormGroup>
        );
    } else if (
        Array.isArray(data?.advice) &&
        data?.advice.some((advice) =>
            [
                HolterGradingAdvice.verwijzing_polikliniek_cardiologie,
                HolterGradingAdvice.aanvullend_slaaponderzoek_naar_osas_viaKsyos,
                HolterGradingAdvice.opvolgend_teleconsult_cardioloog_via_ksyos,
            ].includes(advice)
        )
    ) {
        return (
            <FormGroup
                isRequired
                label="Urgentie verwijzing"
            >
                <Select
                    error={getValidationErrorTranslation(errors.get('urgency'))}
                    onChange={(urgency) => urgency && onChange(urgency.value)}
                    options={holterGradingUrgencyOptions.map((value) => ({
                        label: value,
                        value,
                    }))}
                    placeholder=""
                    value={data.urgency ? { label: data.urgency, value: data.urgency } : null}
                />
            </FormGroup>
        );
    }

    return <></>;
}
